import { render, staticRenderFns } from "./LessonCard.vue?vue&type=template&id=4dd2ea58&scoped=true&"
import script from "./LessonCard.vue?vue&type=script&lang=js&"
export * from "./LessonCard.vue?vue&type=script&lang=js&"
import style0 from "./LessonCard.vue?vue&type=style&index=0&id=4dd2ea58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd2ea58",
  null
  
)

export default component.exports